import styled, {keyframes} from "styled-components";
import { Carousel } from "react-responsive-carousel";

const fromBottomRight = keyframes`
  0% {
    opacity: 0;
    top: 50px;
    left: 50px;
  }
  100% {
    opacity: 1;
    top: 0;
    left: 0;
  }
`

const fromBottomLeft = keyframes`
  0% {
    opacity: 0;
    top: 50px;
    left: -50px;
  }
  100% {
    opacity: 1;
    top: 0;
    left: 0;
  }
`

export const ProjectsSection = styled.section`
  width: 100vw;
  padding-top: 20px;
  overflow: hidden;
  display: flex;
  justify-content: center;

  .container {
    width: 80%;
    max-width: 1000px;
    h2 {
      max-width: 200px;
      height: 60px;
      position: relative;
      right: 0;
    }
  }

  .showL {
    animation: ${fromBottomLeft} 0.5s forwards;
  }

  .showR {
    animation: ${fromBottomRight} 0.5s forwards;
  }
`;

export const ProjectsContainer = styled.div`
  opacity: 0;
  height: 80%;
  max-height: 420px;
  background-color: #fff;
  position: relative;
  border-radius: 20px;
`

export const CustomCarousel = styled(Carousel)`
  height: 100%;

  .carousel {
    height: 100%;
    .slider-wrapper {
      height: 100%;

      ul {
        height: 100%;
        li {
          height: 100%;
        }
      }
    }
    .carousel-status {
      margin-right: 10px;
      font-size: 12px;
    }
  }


  button {
    width: 70px;
  }

`

export const CustomCarouselMobile = styled(Carousel)`

  .carousel .carousel-status {
    margin-right: 10px;
    font-size: 12px;
  }
  
  button {
    width: 70px;
  }

`
